export default __webpack_public_path__ + "static/media/running_shoes.212228de.png";